//
//  WARNING:
//  THIS CODE HAS BEEN GENERATED BY myCodeGenerator (by Sebastien Frippiat).
//  DO NOT EDIT IT DIRECTLY.
//

import { Component, Input, Output, TemplateRef, EventEmitter, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DataSourceLoadOptionsBase } from 'src/api/models';
import { TranslateService } from '@ngx-translate/core';
import { PhotosPdaService } from 'src/api/services';
import CustomStore from 'devextreme/data/custom_store';
import { LoadOptions } from 'devextreme/data/load_options';
import { confirm } from 'devextreme/ui/dialog';

import { DxDataGridComponent, DxTooltipComponent } from 'devextreme-angular';
import { TypeMessage, NotificationService } from 'src/core/services/notification.service';
import { on } from 'devextreme/events';
import { Router } from '@angular/router';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';

@Component({
  selector: 'app-photospda-select-datagrid',
  templateUrl: './photospda.datagrid.component.html',
  styleUrls: ['./photospda.datagrid.component.css']
})
export class PhotosPdaDatagridComponent implements OnInit, OnDestroy {

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild(DxTooltipComponent, { static: false }) tooltip: DxTooltipComponent;
  ToolTipContent = '';
  
  onLoadedDone = false;



  @Input() Visible: boolean = true;
  @Input() AllowCreate: boolean = false;
  @Input() AllowEdit: boolean = false;
  @Input() PageSizeInit: number = 10;
  @Input() SelectionMode: string = "multiple";
  @Input() StateStoring: boolean = false;


  @Input() ParcIdColumnAllowEdit: boolean = false;
  @Input() customParcIdColumnTemplate: TemplateRef<any>;

  @Input() DateColumnAllowEdit: boolean = false;

  @Input() ImageColumnAllowEdit: boolean = false;
  @Input() customImageColumnTemplate: TemplateRef<any>;

  @Input() parcIdParam: any;
  @Input() customParcIdColumnFilter: any;
  @Output() onDetails: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();


  @Output() onLoaded: EventEmitter<any> = new EventEmitter();
  @Output() onCreateOrUpdate: EventEmitter<any> = new EventEmitter();
  @Output() onStateRefresh: EventEmitter<any> = new EventEmitter();


  @Input() OnCellEditingStart: (e: any) => void;
  @Input() OnSelectedRowsChanged: (ids: string[]) => void;




  CurrentColumnTooltip = '';


  public PhotosPdaGridStore: any = {};

  UrlRegex = /.*pbx/;

  constructor(private store: Store,
              private router: Router,
              private translate: TranslateService,
              private photospdaService: PhotosPdaService,
              private notificationService: NotificationService) {
                this.PhotosPdaGridStore = new CustomStore({
                  key: 'Id',
                  load: (loadOptions: LoadOptions) => {

                    const filter = loadOptions.filter;

                    const o: DataSourceLoadOptionsBase = {};
                    o.Skip = loadOptions.skip;
                    o.Take = loadOptions.take;
                    o.RequireTotalCount = loadOptions.requireTotalCount;
                    o.RequireGroupCount = loadOptions.requireGroupCount;
                    o.Sort = loadOptions.sort;
                    o.Filter = filter;
                    o.TotalSummary = loadOptions.totalSummary;
                    o.Group = loadOptions.group;
                    o.GroupSummary = loadOptions.groupSummary;
                    return this.photospdaService.photoPdaLoadList({ parcId: this.parcIdParam, body: o })
                      .toPromise()
                      .then(result => {

                          this.onLoaded.emit(result);
						  this.onLoadedDone = true;

                          return {
                              data: result.data,
                              totalCount: result.totalCount,
                              summary: result.summary,
                              groupCount: result.groupCount
                          };
                      });
                  },
                  insert: (values: any) => {
                    return this.photospdaService.photoPdaPost({ body: values })
                      .toPromise()
                      .then(result => {
                        if (result) {
                          // create success message not specified
                          this.onCreateOrUpdate.emit(result);
                        } else {
                          // create error message not specified
                        }
                      }, (error: HttpErrorResponse) => {
                          // create error message not specified
                      });
                    }
,
                  update: (key, values) => {
                    return this.photospdaService.photoPdaPut({ id: key, body: values})
                      .toPromise()
                      .then(result => {
                        if (result) {
                          // update success message not specified
                          this.onCreateOrUpdate.emit(result);
                        } else {
                          // update error message not specified
                        }
                      }, (error: HttpErrorResponse) => {
                          // update error message not specified
                      });
                    }
                });
              }

  ngOnInit() {

  }

  ngOnDestroy() {
  }

  OnCellPrepared(e) {
    if (e.rowType === 'data') {
      if (e.column.type === 'buttons') { // ACTIONS BUTTON COLUMN
        for (const iconElement of e.cellElement.children[0].children[0].children) {
          // MOUSE OVER EVENT
          on(iconElement, 'mouseover', arg => {
            this.CurrentColumnTooltip = 'Actions';
          });
          // MOUSE OUT EVENT
          on(iconElement, 'mouseout', arg => {
            this.tooltip.instance.hide();
          });
        }
      } else { // NORMAL COLUMN
      }
    }
  }

  OnEditingStart(e) {
    if (this.OnCellEditingStart != null) {
      this.OnCellEditingStart(e);
    }
  }

  OnSelectionChanged(e) {
    if (this.OnSelectedRowsChanged != null) {
      this.OnSelectedRowsChanged(e.selectedRowKeys);
    }
  }


  public GetSelectedRowsId() {
    return this.dataGrid.instance.getSelectedRowKeys();
  }

  public SetSelectedRowsId(ids: string[]) {
    this.dataGrid.instance.selectRows(ids, false);
  }

  public GetSelectedRowsData() {
    return this.dataGrid.instance.getSelectedRowsData();
  }  

  public Refresh() {
    this.dataGrid.instance.refresh();
  }

  public SetColumnsAllowEdit(value: boolean) {
    this.ParcIdColumnAllowEdit = value;
    this.DateColumnAllowEdit = value;
    this.ImageColumnAllowEdit = value;
  }
  
  public onResetStoreClick() {
    this.dataGrid.instance.state(null);
	this.onStateRefresh.emit();
  }
}
